'use client';

import React, { useMemo } from 'react';
import { useTranslation } from '@/app/features/language/hooks/useTranslation';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Home, AlertCircle } from 'lucide-react';
import { useRouter } from 'next/navigation';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation('errors');
  const router = useRouter();

  // Memoize style object to prevent re-creating on every render
  const containerStyle = useMemo(() => ({ paddingTop: '64px' }), []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 dark:from-gray-900 dark:via-slate-900 dark:to-indigo-950 flex items-center justify-center p-4" style={containerStyle}>
      <Card className="max-w-md w-full p-8 text-center shadow-xl">
        <CardContent className="space-y-6">
          <AlertCircle className="w-20 h-20 mx-auto text-destructive" />
          <h1 className="text-4xl font-bold text-foreground">
            {t('404.title')}
          </h1>
          <p className="text-lg text-muted-foreground">
            {t('404.message')}
          </p>
          <Button
            onClick={() => router.push('/')}
            className="w-full"
            size="lg"
          >
            <Home className="w-4 h-4 mr-2" />
            {t('404.backHome')}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFoundPage;